<template>
  <div elevation="0">
    <div class="pa-3">
      <div class="title">Button Themes</div>
      <div
        style="display: flex; flex-wrap: wrap; justify-content: space-around"
      >
        <div
          v-for="(buttonTheme, index) in buttonThemes"
          :key="index"
          class="button-theme"
          @click="chooseButtonTheme(buttonTheme)"
          :class="{ active: isSelectedTheme(buttonTheme) }"
        >
          <a-layout-without-head
            :siteTheme="mixSiteThemeAndButton(buttonTheme)"
            :project="selectedProject"
          >
            <a-link
              text="Register"
              :isButton="true"
              :isShadowed="true"
              :small="true"
            ></a-link>
            <div class="mt-2"></div>
            <a-link
              :isOutlined="true"
              text="Sign up"
              :isButton="true"
              :isShadowed="true"
              :small="true"
            ></a-link>
          </a-layout-without-head>
        </div>
      </div>
      <div class="title">Other Settings</div>
      <SliderInput
        label="Buttons Radius"
        :sliderValue="selectedProject.siteTheme.buttonRadius"
        min="0"
        max="30"
        @change="
          UPDATE_PROJECT_PROP({
            prop: ['siteTheme', 'buttonRadius'],
            value: $event,
          });
          onInputSaveTheme();
        "
      />
      <SliderInput
        label="Inputs Radius"
        :sliderValue="selectedProject.siteTheme.inputRadius"
        min="0"
        max="30"
        @change="
          UPDATE_PROJECT_PROP({
            prop: ['siteTheme', 'inputRadius'],
            value: $event,
          });
          onInputSaveTheme();
        "
      />
    </div>
  </div>
</template>

<script>
import projectMixin from "./project-mixin";
import SliderInput from "../SliderInput";

function bt(bg1, t1, bg2, t2) {
  return {
    button: {
      background: bg1,
      text: t1,
    },
    buttonLight: {
      background: bg2,
      text: t2,
    },
  };
}

export default {
  mixins: [projectMixin],
  components: { SliderInput },
  data() {
    return {
      buttonThemes: [
        bt("#2a2c30", "#FFFFFF", "#E9F1F9", "#2a2c35"),
        bt("#164085", "#FFFFFF", "#E9F1F9", "#1B2431"),
        bt("#292961", "#FFFFFF", "#e9f2fb", "#2a2c35"),
        bt("#9580F9", "#FFFFFF", "#E9F1F9", "#9580FF"),
        bt("#508DE9", "#FFFFFF", "#E9F1F9", "#508DE8"),
        bt("#29C852", "#FFFFFF", "#E4FEED", "#1B2431"),
        bt("#FD3F09", "#FFFFFF", "#FED7C9", "#FD3F09"),
        bt("#FF81B9", "#FFFFFF", "#FED7C9", "#2a2c35"),
        bt("#293462", "#FFFFFF", "#abd8ec", "#293462"),
      ],
    };
  },
  methods: {
    mixSiteThemeAndButton(buttonTheme) {
      let siteTheme = JSON.parse(
        JSON.stringify(this.selectedProject.siteTheme)
      );
      siteTheme.button.background = buttonTheme.button.background;
      siteTheme.button.text = buttonTheme.button.text;
      siteTheme.buttonLight.background = buttonTheme.buttonLight.background;
      siteTheme.buttonLight.text = buttonTheme.buttonLight.text;
      return siteTheme;
    },
    chooseButtonTheme(buttonTheme) {
      this.UPDATE_PROJECT_PROP({
        prop: ["siteTheme", "button", "background"],
        value: buttonTheme.button.background,
      });
      this.UPDATE_PROJECT_PROP({
        prop: ["siteTheme", "button", "text"],
        value: buttonTheme.button.text,
      });
      this.UPDATE_PROJECT_PROP({
        prop: ["siteTheme", "buttonLight", "background"],
        value: buttonTheme.buttonLight.background,
      });
      this.UPDATE_PROJECT_PROP({
        prop: ["siteTheme", "buttonLight", "text"],
        value: buttonTheme.buttonLight.text,
      });
      this.onInputSaveTheme();
    },
    isSelectedTheme(buttonTheme) {
      var button = this.selectedProject.siteTheme.button;
      var buttonLight = this.selectedProject.siteTheme.buttonLight;
      if (
        button.text === buttonTheme.button.text &&
        buttonLight.text === buttonTheme.buttonLight.text &&
        button.background === buttonTheme.button.background &&
        buttonLight.background === buttonTheme.buttonLight.background
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.button-theme {
  padding: 5px;
  display: flex;
  justify-content: center;
  border: 1px solid #efefef;
  border-radius: 5px;
  margin: 3px;
  cursor: pointer;
  transition: 100ms all;
}
.button-theme:hover {
  border: 1px solid #cccccc;
}
.button-theme.active {
  border: 1px solid #292961;
}
</style>